/**
 * KTUI - Free & Open-Source Tailwind UI Components by Keenthemes
 * Copyright 2025 by Keenthemes Inc
 */

export { KTScrollspy } from './scrollspy';
export type { KTScrollspyConfigInterface, KTScrollspyInterface } from './types';
